import { ICsfStorageKeys } from '../interfaces/i-csf-storage-keys'

const prefix = 'x3ui'

export const csfStorageKeys: ICsfStorageKeys = {
  filter: `${prefix}-css-filter`,
  filters: `${prefix}-css-filters`,
  targetValue: `${prefix}-css-filters-target`,
  dismissed: `${prefix}-css-filters-dismissed`,
  switch: `${prefix}-css-filters-switch`,
  location: `${prefix}-css-filters-location`,
}
